(() => {
  const config = JSON.parse(document.getElementById('liora-washer-gifts-config').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const units = item => Number(item.properties?._liora_pressure_washer_pack_units) || ({49829885378715: 1, 49829885411483: 2, 49829885444251: 3}[item.variant_id]) || 1;
  const request = async (path, payload) => {
    const response = await fetch(`${root}cart/${path}.js`, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(payload)});
    const state = await response.json();
    if (!response.ok || state.errors) throw new Error(state.description || 'Could not synchronize washer gifts');
    return state;
  };
  let pending = null;
  window.LioraWasherGifts = {
    units,
    async sync(state, sections) {
      if (pending) { await pending; state = await fetch(`${root}cart.js`).then(r => r.json()); }
      const operation = async () => {
        const desired = state.items.filter(item => item.handle === 'cordless-pressure-washer').reduce((total, item) => total + units(item) * item.quantity, 0);
        const marked = state.items.filter(item => item.properties?._liora_pressure_washer_gift === 'true');
        if (!desired && !marked.length) return state;
        const updates = {}, missing = [];
        for (const gift of config) {
          if (!gift.id) continue;
          const lines = marked.filter(item => Number(item.variant_id) === gift.id && (!item.properties._liora_pressure_washer_gift_type || item.properties._liora_pressure_washer_gift_type === gift.type));
          lines.forEach((item, index) => { const target = index === 0 ? desired : 0; if (item.quantity !== target) updates[item.key] = target; });
          if (desired && !lines.length && gift.available) missing.push({id: gift.id, quantity: desired, properties: {_liora_pressure_washer_gift: 'true', _liora_pressure_washer_gift_type: gift.type, _liora_pressure_washer_parent_variant: 'cordless-pressure-washer', _מתנה: 'כן', _עבור: 'מכונת שטיפה'}});
        }
        if (!Object.keys(updates).length && !missing.length) return state;
        if (missing.length) await request('add', {items: missing});
        return request('update', {updates, sections, sections_url: window.location.pathname});
      };
      pending = operation();
      try { return await pending; } finally { pending = null; }
    }
  };
})();
